import { engineComponent } from "neo-common";
import { GambleController } from "./GambleController";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../../HTMLComponents/Elements/HtmlContainerElement";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { PlayList } from "../../Components/Sounds/PlayList";
import { GameManager } from "../../Managers/GameManager";

@engineComponent(ComponentTypes.DisplayObject)
export class GambleView extends ContainerElement {
    private _controller: GambleController;

    private _gambleControls: HTMLElement;
    private _gambleRedBtn: HTMLElement;
    private _gambleBlackBtn: HTMLElement;
    private _gambleActualCard: HTMLElement;
    private _gambleCardBack: HTMLElement;
    private _gambleWin: HTMLElement;
    private _gambleWin2: HTMLElement;
    private _previousCards: Array<HTMLElement>;

    private _actualColor: string;

    private _revealTimer: FrameTimerEventEmitter;
    private _revealBackTimer: FrameTimerEventEmitter;
    private _winTimer: FrameTimerEventEmitter;
    private _loseTimer: FrameTimerEventEmitter;
    private _introDelayTimer: FrameTimerEventEmitter;
    private _introSoundTimer: FrameTimerEventEmitter;
    private _outroDelayTimer: FrameTimerEventEmitter;

    constructor() {
        super();

        this._revealTimer = CreateFrameTimer("revealTimer");
        this._revealTimer.on(FrameTimerEvents.Complete, this.reveal.bind(this));

        this._revealBackTimer = CreateFrameTimer("revealTimer");
        this._revealBackTimer.on(FrameTimerEvents.Complete, this.revealBack.bind(this));

        this._winTimer = CreateFrameTimer("revealTimer");
        this._winTimer.on(FrameTimerEvents.Complete, this.win.bind(this));

        this._loseTimer = CreateFrameTimer("revealTimer");
        this._loseTimer.on(FrameTimerEvents.Complete, this.lose.bind(this));

        this._introDelayTimer = CreateFrameTimer("introDelayTimer");
        this._introDelayTimer.on(FrameTimerEvents.Complete, this.introDelayed.bind(this));

        this._introSoundTimer = CreateFrameTimer("introSoundTimer");
        this._introSoundTimer.on(FrameTimerEvents.Complete, this.introSoundStart.bind(this));

        this._outroDelayTimer = CreateFrameTimer("revealTimer");
        this._outroDelayTimer.on(FrameTimerEvents.Complete, this.outroDelayed.bind(this));
    }

    createByNode(node: Element): void {
        super.createByNode(node);
    }

    initReceived(controller: GambleController): void {
        this._controller = controller;

        this._gambleControls = document.getElementById("gamble");

        if (this._gambleControls == null) {
            if (DEBUG) {
                this.log("ERROR no gamble controlls");
            }
        }

        this._gambleActualCard = document.getElementById("gambleActualCard");
        if (this._gambleActualCard == null) {
            if (DEBUG) {
                this.log("ERROR no gambleActualCard");
            }
        }

        this._gambleCardBack = document.getElementById("gambleCardBack");
        if (this._gambleCardBack == null) {
            if (DEBUG) {
                this.log("ERROR no gambleCardBack");
            }
        }

        this._gambleWin = document.getElementById("gambleWin");
        if (this._gambleWin == null) {
            this._gambleWin = document.getElementById("winBox");
            if (this._gambleWin == null) {
                if (DEBUG) {
                    this.log("ERROR no gambleWin");
                }
            }
        }

        this._gambleWin2 = document.getElementById("winBox2");
        if (this._gambleWin2 == null) {
            if (this._gambleWin2 == null) {
                if (DEBUG) {
                    this.log("ERROR no _gambleWin2");
                }
            }
        }

        this._gambleRedBtn = document.getElementById("gambleRedBtn");
        this._gambleBlackBtn = document.getElementById("gambleBlackBtn");
        if (this._gambleRedBtn != null && this._gambleBlackBtn != null) {
            this._gambleRedBtn.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
            this._gambleRedBtn.addEventListener(HtmlContainerElement.TouchStart, this.onOver.bind(this));
            this._gambleRedBtn.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));
            this._gambleRedBtn.addEventListener(HtmlContainerElement.TouchEnd, this.onOut.bind(this));
            this._gambleBlackBtn.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
            this._gambleBlackBtn.addEventListener(HtmlContainerElement.TouchStart, this.onOver.bind(this));
            this._gambleBlackBtn.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));
            this._gambleBlackBtn.addEventListener(HtmlContainerElement.TouchEnd, this.onOut.bind(this));
        }

        this._previousCards = [];
        for (let i: number = 0; i < 5; i++) {
            let card: HTMLElement = document.getElementById("previousCard" + i);
            if (card != null) {
                this._previousCards.push(card);
            }
        }
    }

    initIntro(): void {
        this.previousCards();
        if (this._gambleControls != null && this._gambleControls.classList.contains(HtmlController.DisabledClass)) {
            this._gambleControls.classList.remove(HtmlController.DisabledClass);
            this._gambleControls.style.display = "block";
        }
        PlayList.loop("SND_GambleLoop");
    }

    private onOver(): void {
        if (this._gambleRedBtn != null && !this._gambleRedBtn.classList.contains("_hover")) {
            this._gambleRedBtn.classList.add("_hover");
        }
        if (this._gambleBlackBtn != null && !this._gambleBlackBtn.classList.contains("_hover")) {
            this._gambleBlackBtn.classList.add("_hover");
        }
    }

    private onOut(): void {
        if (this._gambleRedBtn != null && this._gambleRedBtn.classList.contains("_hover")) {
            this._gambleRedBtn.classList.remove("_hover");
        }
        if (this._gambleBlackBtn != null && this._gambleBlackBtn.classList.contains("_hover")) {
            this._gambleBlackBtn.classList.remove("_hover");
        }
    }

    startReceived(): void {
        this.previousCards();
    }

    selectReceived(): void {
        if (GameManager.gambleResponse.currentCard != null) {
            if (this._gambleActualCard != null && this._gambleCardBack != null) {
                this._gambleCardBack.classList.remove("_CA");
                this._gambleCardBack.classList.remove("_DA");
                this._gambleCardBack.classList.remove("_HA");
                this._gambleCardBack.classList.remove("_SA");
                this._gambleCardBack.classList.remove("_JR");
                this._gambleCardBack.classList.add("_" + GameManager.gambleResponse.currentCard);
                this._gambleActualCard.classList.add("_reveal");

                if (GameManager.gambleResponse != null && GameManager.gambleResponse.currentWin > 0) {
                    this._revealTimer.start(30);
                } else {
                    this._revealTimer.start(60);
                }

                PlayList.play("SND_GambleDraw");
            }
        }
    }
    private previousCards(): void {
        if (this._previousCards != null && GameManager.gambleResponse.previousCards != null) {
            for (var i: number = 0; i < GameManager.gambleResponse.previousCards.length; i++) {
                var card: HTMLElement = this._previousCards[i];
                if (card != null) {
                    card.classList.remove("_CA");
                    card.classList.remove("_DA");
                    card.classList.remove("_HA");
                    card.classList.remove("_SA");
                    card.classList.remove("_JR");
                    if (GameManager.gambleResponse.previousCards[i] != "XX") {
                        card.classList.add("_" + GameManager.gambleResponse.previousCards[i]);
                    }
                }
            }
        }
    }

    reAnimate(color: string): boolean {
        if (this._gambleActualCard != null && this._gambleActualCard.classList.contains("_reveal")) {
            this._actualColor = color;
            this._gambleActualCard.classList.remove("_reveal");

            PlayList.play("SND_GambleDraw");

            this._revealBackTimer.start(30);
            return false;
        } else {
            return true;
        }
    }

    disabled(): void {
        if (this._gambleControls != null && !this._gambleControls.classList.contains(HtmlController.DisabledClass)) {
            this._gambleControls.classList.add(HtmlController.DisabledClass);
        }
    }

    intro(): void {
        this._introDelayTimer.start(1);
        if (this._gambleControls != null) {
            this._gambleControls.style.display = "block";
        }
    }

    private introDelayed(): void {
        this._introDelayTimer.stop();
        if (this._gambleControls != null && this._gambleControls.classList.contains(HtmlController.DisabledClass)) {
            this._gambleControls.classList.remove(HtmlController.DisabledClass);
        }
        PlayList.play("SND_transition");
        this._introSoundTimer.start(30);
    }

    private introSoundStart(): void {
        this._introSoundTimer.stop();
        PlayList.loop("SND_GambleLoop");
        this._controller.introFinished();
    }

    outro(): void {
        this._outroDelayTimer.start(15);
        if (this._gambleControls != null && !this._gambleControls.classList.contains(HtmlController.DisabledClass)) {
            this._gambleControls.classList.add(HtmlController.DisabledClass);
        }
        PlayList.play("SND_GambleTransitionOut");
        PlayList.play("SND_transition");
        PlayList.stop("SND_GambleLoop");
    }

    private outroDelayed(): void {
        this._outroDelayTimer.stop();
        if (this._gambleControls != null) {
            this._gambleControls.style.display = "none";
        }
        this._controller.outroFinished();
    }

    reveal(): void {
        this._revealTimer.stop();
        this.previousCards();
        this._controller.winCalculationFinished();

        if (GameManager.gambleResponse != null && GameManager.gambleResponse.currentWin > 0) {
            this._gambleActualCard.classList.remove("_reveal");
            PlayList.play("SND_GambleWin");
            if (this._gambleWin != null && !this._gambleWin.classList.contains("winAnimation")) {
                this._gambleWin.classList.add("winAnimation");
            }
            if (this._gambleWin2 != null && !this._gambleWin2.classList.contains("winAnimation")) {
                this._gambleWin2.classList.add("winAnimation");
            }
            this._winTimer.start(15);
        } else {
            this._gambleActualCard.classList.remove("_reveal");
            this._revealBackTimer.start(30);
            this._loseTimer.start(30);
        }
    }

    revealBack(): void {
        this.onOut(); //remove _hover class
        this._revealBackTimer.stop();
    }

    win(): void {
        this._winTimer.stop();
        this._revealBackTimer.start(5);
        if (this._gambleWin != null && this._gambleWin.classList.contains("winAnimation")) {
            this._gambleWin.classList.remove("winAnimation");
        }
        if (this._gambleWin2 != null && this._gambleWin2.classList.contains("winAnimation")) {
            this._gambleWin2.classList.remove("winAnimation");
        }
        this._controller.allWinsFinished();
    }

    lose(): void {
        this._loseTimer.stop();
        this._controller.lose();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Gamble/GambleView.ts
 **/